<template>
  <div
    class="p-8 space-y-4 text-center text-green-800 rounded-2xl border border-green-200 bg-green-100/60"
  >
    <h2 class="text-xl font-bold">{{ $t("form.step4.title") }}</h2>
    <p>{{ $t("form.step4.line1") }}</p>
    <p class="font-semibold">{{ $t("form.step4.line2") }}</p>
    <p class="text-sm">{{ $t("form.step4.line3") }}</p>
  </div>
</template>
<script>
export default {
  name: "FormStep4",
};
</script>
